// const API_BASE_URL = "http://192.168.29.113:1000/"             //LOCAL PATH
const API_BASE_URL = "https://demo.purnaacademic.in/"    //ONLINE PATH

//============================================================================================

export const IMG_URL = API_BASE_URL + "uploads/"             //IMAGE PATH
export const API_BASE = API_BASE_URL            // BASE API for Namuna Form


export const AdminLoginAPI = API_BASE_URL + "admin_login/AdminLogin"  // Admin Login (POST)

// ===========Dashboard==========
export const DashboardAPI = API_BASE_URL + "dashboard/getDashboard"  // Admin Dashboard (GET)

export const GetExtensionRemainderData = API_BASE_URL + "dashboard/getExtensionsReminderData"  // Admin Dashboard (Get Extension Remainder Data) (GET)

export const GetFormStatusOfStudent = API_BASE_URL + "dashboard/getExtensionsReminderData"  // Admin Dashboard (Get Form Status Of Student) (GET)

export const GetFormCompletionStatus = API_BASE_URL + "dashboard/getFormsPercentage"  // Admin Dashboard (Get Form Completion Status) (GET)

export const GetStudentsBelowFiftyPercent = API_BASE_URL + "dashboard/getStudentsBelowFiftyPercent"  // Admin Dashboard (Get Students Below Fifty Percent) (GET)

//======== Change Password==========
export const changePasswordAPI = API_BASE_URL + "admin_login/changePassword"  // Admin Change Password (POST)


// ========Religion Master================
export const getReligion = API_BASE_URL + "religion/getReligion"  // get Religion (GET)
// export const getReligionById = API_BASE_URL + "religion/getReligionById"  //get Religion by Id (GET)
export const saveReligion = API_BASE_URL + "religion/saveReligion"  // Post Religion (POST)
export const updateReligion = API_BASE_URL + "religion/updateReligionById"  // Put Religion (PUT) (Params= id)
export const deleteReligion = API_BASE_URL + "religion/deleteReligionById"  // Delete Religion (DELETE) (Params= id)

// ========Cast Master================
export const getCast = API_BASE_URL + "cast/getAllCast"  // get Cast (GET)
export const getCastById = API_BASE_URL + "cast/getCastReligionById"  //get Cast by Id (GET) (Params= religion_id)
export const saveCast = API_BASE_URL + "cast/saveCast"  // Post Cast (POST)
export const updateCast = API_BASE_URL + "cast/updateById"  // Put Cast (PUT) (Params= id)
export const deleteCast = API_BASE_URL + "cast/deleteCast"  // Delete Cast (DELETE) (Params= id)

// ========Sub Cast Master================
export const getSubCast = API_BASE_URL + "subcast/getAllSubCast"  // get Sub Cast (GET)
export const getSubCastById = API_BASE_URL + "subcast/getsubCastById"  //get Sub Cast by Id (GET) (Params= cast_id)
export const saveSubCast = API_BASE_URL + "subcast/saveSubCast"  // Post Sub Cast (POST)
export const updateSubCast = API_BASE_URL + "subcast/updateSubCast"  // Put Sub Cast (PUT) (Params= id)
export const deleteSubCast = API_BASE_URL + "subcast/deleteSubCastById"  // Delete Sub Cast (DELETE) (Params= id)

// ========Act and Section Master================
export const getActSection = API_BASE_URL + "actandsection/getAllActAndSec"  // get Act-Section (GET)
export const getActSectionById = API_BASE_URL + "actandsection/getActAndSecById"  //get Act-Section by Id (GET) (Params= cast_id)
export const saveActSection = API_BASE_URL + "actandsection/saveActAndSec"  // Post Act-Section (POST)
export const updateActSection = API_BASE_URL + "actandsection/updateActAndSecById"  // Put Act-Section (PUT) (Params= id)
export const deleteActSection = API_BASE_URL + "actandsection/deleteActAndSec"  // Delete Act-Section (DELETE) (Params= id)

// ========Building Master================
export const getBuilding = API_BASE_URL + "building/getAllBuildings"  // get Building (GET)
export const saveBuilding = API_BASE_URL + "building/createBuilding"  // Post Building (POST)
export const updateBuilding = API_BASE_URL + "building/updateBuilding"  // Put Building (PUT) (Params= id)
export const deleteBuilding = API_BASE_URL + "building/deleteBuilding"  // Delete Building (DELETE) (Params= id)

// ========Floor Master================
export const getFloor = API_BASE_URL + "wings/getAllWing"  // get Floor (GET)
export const getFloorById = API_BASE_URL + "wings/getWingById"  //get Floor by Id (GET) (Params= id)
export const saveFloor = API_BASE_URL + "wings/createWing"  // Post Floor (POST)
export const updateFloor = API_BASE_URL + "wings/updateWing"  // Put Floor (PUT) (Params= id)
export const deleteFloor = API_BASE_URL + "wings/deleteWing"  // Delete Floor (DELETE) (Params= id)

//#############  FORMS ################

// ======= Student List========== 
export const getChildrenList = API_BASE_URL + "registration/getAllRegistration"  // Get Admission List (GET)

// ======= Student Admission Form==========
export const CreateStudentAdmission = API_BASE_URL + "registration/createRegistration"  // Create Admission (POST)
export const GetStudentAdmission = API_BASE_URL + "registration/getAllRegistration"  // Get Admission List (GET)
export const UpdateStudentAdmission = API_BASE_URL + "registration/updateRegistration"  // Update Admission (POST) (Params=> id)
export const DeleteStudentAdmission = API_BASE_URL + "registration/deleteRegistration"  // Delete Admission (DELETE) (Params=> id)
//-----------------------------------
export const GetAllFormStatusOfStudent = API_BASE_URL + "registration/getAllFormStatus"  // Get All Form Status Of Students(show in View Modal for controlling forms) (GET) (Params=> id)


// ======= Parents Document Form==========
export const saveParentsDocuments = API_BASE_URL + "parent_info_doc/createParentInfoAndDoc"  // Save Parents Document (POST) 
export const GetParentsDocuments = API_BASE_URL + "parent_info_doc/getAllParentInfoAndDoc"  // Get Parents Document (GET) 
export const GetParentsDocumentsById = API_BASE_URL + "parent_info_doc/getParentInfoAndDoc"  // Get Parents Document (GET) (params => (reg_id))
export const UpdateParentsDocuments = API_BASE_URL + "parent_info_doc/updateParentInfoAndDoc"  // Update Parents Document (PUT) (params => (reg_id))
export const DeleteParentsDocuments = API_BASE_URL + "parent_info_doc/deleteParentInfoAndDoc"  // Delete Parents Documents (DELETE) (Params=> id)


// ======= Police Document Form==========
export const savePoliceDocuments = API_BASE_URL + "firAndPoliceDocuments/createFirWithDocuments"  // Save Police Document (POST) 
export const GetPoliceDocumentsById = API_BASE_URL + "firAndPoliceDocuments/getFirByRegId"  // Get Police Document BY ID (GET) (params => (reg_id))
export const GetPoliceDocuments = API_BASE_URL + "firAndPoliceDocuments/getAllFirWithDocuments"  // Get Police Document (GET)

export const DeletePoliceDocuments = API_BASE_URL + "firAndPoliceDocuments/deleteFirWithDocuments"  // Delete Police Documents (DELETE) (Params=> reg_id)


// ======= Room Allocation Form==========
export const saveRoomAllocation = API_BASE_URL + "room_allocation/createRoomAllocation"  // Save Room Allocation (POST) 
export const GetRoomAllocation = API_BASE_URL + "room_allocation/getAllRoomAllocation"  // Get Room Allocation (GET) 
export const updateRoomAllocation = API_BASE_URL + "room_allocation/updateRoomAllocation"  // Update Room Allocation (PUT)  (params => (id))
export const DeleteRoomAllocation = API_BASE_URL + "room_allocation/deleteRoomAllocation"  // Delete Room Allocation  (DELETE) (Params=> id)

// ======= Educational Document Form==========
export const saveEducationalDocuments = API_BASE_URL + "education_info_doc/createEducationInfoDoc"  // Save Educational Docs (POST) 
export const GetEducationalDocumentsById = API_BASE_URL + "education_info_doc/getEducationInfoDocById"  // Get Educational Docs (GET)  (params => (reg_id))
export const GetEducationalDocuments = API_BASE_URL + "education_info_doc/getAllEducationInfoDoc"  // Get Educational Docs (GET) 
export const UpdateEducationalDocuments = API_BASE_URL + "education_info_doc/updateEducationInfoDoc"  // Update Educational Docs (PUT)  (params => (reg_id))
export const DeleteEducationalDocuments = API_BASE_URL + "education_info_doc/deleteEducationInfoDoc"  // Delete Educational Documents  (DELETE) (Params=> id)

// ======= Medical Document Form==========
export const saveMedicalDocuments = API_BASE_URL + "medical_info_doc/createMedicalInfoDocs"  // Save Medical Docs (POST) 
export const GetMedicalDocumentsById = API_BASE_URL + "medical_info_doc/getMedicalInfoDocsById"  // Get Medical Docs (GET)  (params => (reg_id))
export const GetMedicalDocuments = API_BASE_URL + "medical_info_doc/getAllMedicalInfoDocs"  // Get Medical Docs (GET) 
export const UpdateMedicalDocuments = API_BASE_URL + "medical_info_doc/updateMedicalInfoDocs"  // Update Medical Docs (PUT)  (params => (reg_id))
export const DeleteMedicalDocuments = API_BASE_URL + "medical_info_doc/deleteMedicalInfoDocs"  // Delete Medical Documents  (DELETE) (Params=> id)

// ======= Girls Statement Document Form==========
export const saveGirlsStatementDocuments = API_BASE_URL + "girls_statement_docs/createGirlsStatementAndDoc"  // Save Girls Statement Docs (POST) 
export const GetGirlsStatementDocumentsById = API_BASE_URL + "girls_statement_docs/getGirlsStatementByRegId"  // Get Girls Statement Docs (GET)  (params => (reg_id))
export const GetGirlsStatementDocuments = API_BASE_URL + "girls_statement_docs/getAllGirlsStatementAndDoc"  // Get Girls Statement Docs (GET) 
export const DeleteGirlsStatementDocuments = API_BASE_URL + "girls_statement_docs/deleteGirlsStatementAndDoc"  // Delete Girls Statement Docs (DELETE)  (params => (reg_id))

// ======= Discharge Form==========
export const saveDischargeData = API_BASE_URL + "discharge/createDischarge"  // Save Discharge Data (POST) 
export const GetDischargeData = API_BASE_URL + "discharge/getAllDischarge"  // Get Discharge Data (GET) 
export const updateDischargeData = API_BASE_URL + "discharge/updateDischarge"  // Update Discharge Data (PUT) 
export const DeleteDischargeData = API_BASE_URL + "discharge/deleteDischarge"  // Delete Discharge Data (DELETE)  (params => (reg_id))


// ======= Counsellor Form==========
export const saveCounsellorData = API_BASE_URL + "counselling/AddCounsellingData"  // Save Counsellor Data (POST) 
export const GetCounsellorData = API_BASE_URL + "counselling/getAllCounsellingData"  // Get Counsellor Data (GET) 
export const updateCounsellorData = API_BASE_URL + "counselling/updateCounsellingData"  // Update Counsellor Data (PUT)  (params => (reg_id))
export const DeleteCounsellorData = API_BASE_URL + "counselling/deleteCounsellingData"  // Delete Counsellor Data  (DELETE) (Params=> reg_id)


// ======= NAMUNA FORMS==========
//------ Namuna18--------
export const saveNamuna18Data = API_BASE_URL + "namuna/createNamunaEighteen"  // Save Namuna 18 Data (POST) 
export const getNamuna18Data = API_BASE_URL + "namuna/getNamunaEighteen"  // Get Namuna 18 Data (GET)  (params=> reg_id)

//------ Namuna45--------
export const saveNamuna45Data = API_BASE_URL + "namuna/createNamunaFortyFive"  // Save Namuna 45 Data (POST) 
export const getNamuna45Data = API_BASE_URL + "namuna/getNamunaFortyFive"  // Get Namuna 45 Data (GET)  (params=> reg_id)

//------ Namuna22--------
export const saveNamuna22Data = API_BASE_URL + "namuna/createNamunaTwentyTwo"  // Save Namuna 22 Data (POST) 
export const getNamuna22Data = API_BASE_URL + "namuna/getNamunaTwentyTwo"  // Get Namuna 22 Data (GET)  (params=> reg_id)

//------ Namuna7--------
export const saveNamuna7Data = API_BASE_URL + "namuna/createNamunaSeven"  // Save Namuna 7 Data (POST) 
export const getNamuna7Data = API_BASE_URL + "namuna/getNamunaSeven"  // Get Namuna 7 Data (GET)  (params=> reg_id)

//------ Namuna9--------
export const saveNamuna9Data = API_BASE_URL + "namuna/createNamunaNine"  // Save Namuna 9 Data (POST) 
export const getNamuna9Data = API_BASE_URL + "namuna/getNamunaNine"  // Get Namuna 9 Data (GET)  (params=> reg_id)

//------ Namuna20--------
export const saveNamuna20Data = API_BASE_URL + "namuna/createNamunaTwenty"  // Save Namuna 20 Data (POST) 
export const getNamuna20Data = API_BASE_URL + "namuna/getNamunaTwenty"  // Get Namuna 20 Data (GET)  (params=> reg_id)



// ======= Case File Form==========
export const getCaseFileData = API_BASE_URL + "case_file/getCaseFileData"  // Get Case File Data (GET) 
export const saveCaseFileData = API_BASE_URL + "case_file/createCaseFileData"  // Save Case File Data (POST) 
export const getCaseFileDataById = API_BASE_URL + "case_file/getCaseFileDataByRegId"  // Get Case File Data (GET)  (Params=> reg_id)
export const updateCaseFileData = API_BASE_URL + "case_file/updateCaseFileData"  // Update Case File Data (GET)  (Params=> reg_id)


// ======= Children's Home Visit ==========
export const saveChildrenHomeVisitData = API_BASE_URL + "children_home_visit/createChildrenHomeVisitData"  // Save Children Home Visit Data (POST) 
export const GetChildrenHomeVisitData = API_BASE_URL + "children_home_visit/getAllChildrenHomeVisitData"  // Get Children Home Visit Data (GET) 
export const updateChildrenHomeVisitData = API_BASE_URL + "children_home_visit/updateChildHomeVisitData"  // Update Children Home Visit Data (PUT)  (params => (id))
export const DeleteChildrenHomeVisitData = API_BASE_URL + "children_home_visit/deleteChildHomeVisitData"  // Delete Children Home Visit Data  (DELETE) (Params=> id)



// ############################# ADMIN ###################################


// ========Role Master================
export const getRole = API_BASE_URL + "role_master/getAllRoleMaster"  // get Role (GET)
export const saveRole = API_BASE_URL + "role_master/createRole"  // Post Role (POST)
export const updateRole = API_BASE_URL + "role_master/updateRole"  // Put Role (PUT) (Params= id)

// ========Page Master================
export const getPage = API_BASE_URL + "page_master/getAllPages"  // Get Page (GET)
export const getPageByMenu = API_BASE_URL + "page_master/getPagesByMenuId"  // Get Page By Menu Id (GET) (Params= menu id)
export const savePage = API_BASE_URL + "page_master/createPages"  // Post Page (POST)
export const updatePage = API_BASE_URL + "page_master/updatePages"  // Put Page (PUT) (Params= id)

// ========Menu Master================
export const getMenu = API_BASE_URL + "menu_master/getAllMenuMaster"  // Get Menu (GET)
export const saveMenu = API_BASE_URL + "menu_master/createMenuMaster"  // Post Menu (POST)
export const updateMenu = API_BASE_URL + "menu_master/updateMenuMaster"  // Put Menu (PUT) (Params= id)

// ========User Creation================
export const getUser = API_BASE_URL + "user_menu_page/getAllUserPage"  // Get User (GET)
export const saveUser = API_BASE_URL + "user_menu_page/createUserAndAssignMenuPages"  // Post User (POST)
export const updateUser = API_BASE_URL + "user_menu_page/updateUserAndAssignMenuPages"  // Put User (PUT) (Params= id)

export const updateUserStatus = API_BASE_URL + "user_creation/block_Unblock_User"  // Put User (PUT) (Params= id)

// ========Page Allocation================
export const getPageAllocation = API_BASE_URL + "userPageAllocation/getAllUserPageAllocation"  // Get Page Allocation (GET)
export const savePageAllocation = API_BASE_URL + "userPageAllocation/assignUserPages"  // Post Page Allocation (POST)
export const updatePageAllocation = API_BASE_URL + "userPageAllocation/updateUserPages"  // Put Page Allocation (PUT) (body= id)

//-----For Go to Edit--------------
export const getUserMenuPages = API_BASE_URL + "userPageAllocation/getUserIdAndMenuId"  // Post Page Allocation By Selecting Menu And User (POST) 

// ========Page Allocation For Role================
export const getRoleAllocationList = API_BASE_URL + "role_menu_page/getAllRoleMenuPage"  // Get Page Allocation for Role (GET)
export const getRoleAllocationById = API_BASE_URL + "role_menu_page/getRoleMenuPageById"  // Get Page Allocation for Role By Id (GET) (params=> role_id)
export const saveRoleAllocation = API_BASE_URL + "role_menu_page/assignRoleMenusPages"  // Post Page Allocation for Role (POST)
export const updateRoleAllocation = API_BASE_URL + "role_menu_page/updateRoleMenusPages"  // Put Page Allocation for Role (PUT)


// ========Extension Entry================
export const getExtensionEntry = API_BASE_URL + "extension/getAllExtensionData"  // Get Extension Entry (GET)
export const getExtensionEntryById = API_BASE_URL + "extension/getExtensionDataById"  // Get Extension Entry (GET) (params => reg_id)
export const saveExtensionEntry = API_BASE_URL + "extension/createExtensionData"  // Post Extension Entry (POST)

export const deleteExtensionEntry = API_BASE_URL + "extension/deleteExtensionData"  // Delete Extension Entry from inner table (PUT) (params => id) 

export const GetExtensionEntryCount = API_BASE_URL + "extension/getExtensionDataCount"  // Get Extension Entry Count for remainder (GET)

// ###################### REPORTS API #######################

export const GetStudentAdmissionDataById = API_BASE_URL + "registration/getRegistrationById"  // Get Admission List (GET) (params => reg_id) (REPORT)

export const GetParentInfoAndDocById = API_BASE_URL + "parent_info_doc/getParentInfoAndDoc"  // Get Parent Info & Doc (GET) (params => reg_id) (REPORT)

export const GetFirAndPoliceDocById = API_BASE_URL + "firAndPoliceDocuments/getFirByRegId"  // Get Fir & Police Doc (GET) (params => reg_id) (REPORT)

export const GetHomeVisitById = API_BASE_URL + "children_home_visit/getChildrenHomeVisitDataByRegId"  // Get Home Visit (GET) (params => reg_id) (REPORT)

export const GetEducationalInfoAndDocById = API_BASE_URL + "education_info_doc/getEducationInfoDocById"  // Get Educational Info & Doc (GET) (params => reg_id) (REPORT)

export const GetMedicalInfoAndDocsById = API_BASE_URL + "medical_info_doc/getMedicalInfoDocsById"  // Get Medical Info & Doc (GET) (params => reg_id) (REPORT)

export const GetGirlStatementAndDocsById = API_BASE_URL + "girls_statement_docs/getGirlsStatementByRegId"  // Get Girl Statement & Doc (GET) (params => reg_id) (REPORT)

export const GetCaseFileDataById = API_BASE_URL + "case_file/getCaseFileDataByRegId"  // Get Case File Data (GET) (params => reg_id) (REPORT)

export const GetCounsellingDataById = API_BASE_URL + "counselling/getCounsellingDataByRegId"  // Get Counselling Data (GET) (params => reg_id) (REPORT)
// ================
export const GetAllDischargeStudent = API_BASE_URL + "report/getAllDischargeStudent"  // Get Discharge Student Data (GET) (REPORT)
export const GetDischargeDataById = API_BASE_URL + "discharge/getDischargeByRegId"  // Get Discharge Data (GET) (params => reg_id) (REPORT)

//=======================

export const GetNamunaDataById = API_BASE_URL + "report/getAllNamunaData"  // Get Namuna Data (GET) (params => reg_id) (REPORT)

export const GetRoomAllocationDataById = API_BASE_URL + "room_allocation/getAllRoomAllocationByRegId"  // Get Room Allocation Data (GET) (params => reg_id) (REPORT)

